import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@crew-occ/react-components/styles';
import './index.css';
import App from './ui/App';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
